<template>
  <Modal
    v-if="!firstLoading"
    height="677px"
    width="912px"
    @close="$emit('close')"
  >
    <h2 style="margin-bottom: 24px">Журнал изменений</h2>
    <div
      class="scroll"
      ref="scroll"
      @scroll="(evt) => !allPageLoaded && getNextPage(evt)"
    >
      <VTable
        itemsType="array"
        :columns="headers"
        :loading="nextPageLoading"
        :items="mapedHistory"
        :sortApi="sortHistory"
        ref="table"
      >
        <template v-slot:col-5="{ data }">
          <div style="display: flex">
            <VStatus
              v-if="data && typeof data === 'object'"
              :status="data"
              style="margin: 17px 0"
            />
            <span v-else>{{ data || "-" }}</span>
          </div>
        </template>
        <template v-slot:col-6="{ data }">
          <div style="display: flex">
            <VStatus
              v-if="data && typeof data === 'object'"
              :status="data"
              style="margin: 17px 0"
            />
            <span v-else>{{ data || "-" }}</span>
          </div>
        </template>
      </VTable>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modals/Modal.vue";
import VStatus from "@/components/VStatus.vue";
import VTable from "@/components/Table/VTable.vue";
import PageOptions from "@/models/PageOptions";

import { FIO } from "@/utils/filters/stringFilters";
import { simpleDateWithTime } from "@/utils/filters/dateFilters";
import { getHistory } from "@/api/orders.js";

export default {
  name: "Histoty",
  components: {
    Modal,
    VStatus,
    VTable,
  },
  emits: ["loadingChange"],
  props: {
    orderId: [String, Number],
  },
  async mounted() {
    this.$emit("loading");

    if (this.orderId) {
      this.pageOptions["search[Order]"] = this.orderId;
    }

    try {
      await this.getHistory();
      this.firstLoading = false;
    } catch (err) {
      Promise.reject(err);
      this.$emit("close");
    }

    this.$emit("loading");
  },
  data() {
    return {
      history: [],
      firstLoading: true,
      pageOptions: new PageOptions(),
      nextPageLoading: false,
      allPageLoaded: false,
      headers: [
        { title: "Дата/Время", sort: true, value: "created_at" },
        { title: "Пользователь", sort: true, value: "users.surname" },
        "Событие",
        { title: "№ Заявки", sort: true, value: "honumber" },
        "Было",
        "Стало",
      ],
    };
  },
  computed: {
    mapedHistory() {
      return (
        this.history?.map((event) => {
          const userFIO =
            event.user &&
            FIO(event.user.name, event.user.surname, event.user.patronymic);

          return [
            event.created_at ? simpleDateWithTime(event.created_at) : "-",
            userFIO || "-",
            event.event || "-",
            event.order?.number ? `Заявка № ${event.order?.number}` : "-",
            event.status_old || event.comment_old,
            event.status_current || event.comment_current,
          ];
        }) || []
      );
    },
  },
  methods: {
    async getHistory() {
      this.nextPageLoading = true;

      const response = await getHistory(this.pageOptions);

      if (response.data.length < this.pageOptions["per-page"]) {
        this.allPageLoaded = true;
      }

      this.history = [...this.history, ...response.data];
      this.nextPageLoading = false;
    },
    getNextPage({ target }) {
      const { scrollTop, clientHeight, scrollHeight } = target;
      const isScrollEnd = scrollTop + clientHeight === scrollHeight;

      if (isScrollEnd) {
        this.pageOptions.page += 1;
        this.getHistory();
      }
    },
    sortHistory(col, sort) {
      this.pageOptions = {
        ...this.pageOptions,
        page: 1,
        sort: (sort ? "" : "-") + col?.value,
      };

      this.history = [];
      this.allPageLoaded = false;
      this.getHistory();
    },
  },
};
</script>

<style scoped lang="scss"></style>
